import { AIS_CONTACT_EMAIL, AIS_RU_CONTACT_EMAIL } from '@/components/seo/schema';

/**
 * Публичные ключи окон чата. Видны в исходниках страницы, секретом не являются.
 *
 * Приветствие в Chatwoot задаётся одно на окно, поэтому окно на язык:
 * русское для aisearch.ru, испанское и английское для aisearch.tech.
 * Сербского окна нет — в бесплатной редакции Chatwoot предел 10 окон и
 * ящиков, все заняты. Сербы пишут в английское окно: кнопки и подсказки
 * в нём всё равно по-сербски (их переводит сам Chatwoot по `locale`),
 * английское только приветствие. Отвечают из одного Chatwoot.
 */
const OKNO_RU = 'pirQ7FuWJdfrjRoq2qWQbTqj';
const OKNO_EN = 'x6oVN58JqWvWham8TYA5oQ3N';
const OKNO_ES = 'P5W8A3GQMHwjujZwrsZSy14k';

/** Окно чата для языка страницы и домена. */
export function oknoChata(locale: string, ruDomen: boolean): string {
  if (ruDomen || locale === 'ru') return OKNO_RU;
  return locale === 'es' ? OKNO_ES : OKNO_EN;
}

/** Почта на случай, если чат не открылся: русскоязычным — русский ящик. */
export function pochtaPodderzhki(locale: string, ruDomen: boolean): string {
  return ruDomen || locale === 'ru' ? AIS_RU_CONTACT_EMAIL : AIS_CONTACT_EMAIL;
}
